// DailyTasks.js
import React from 'react';
import styled from 'styled-components';
import { StarIcon, OkxIcon, BinanceIcon } from '../assets/icons/Icons';

const TasksContainer = styled.div`
  margin: 8px;
  padding: 0 4px;
`;

const TasksHeader = styled.div`
  margin-bottom: 8px;
  text-align: left;
`;

const TasksTitle = styled.h2`
  font-size: 18px;
  margin: 0;
  margin-bottom: 3px;
`;

const TasksDescription = styled.p`
  font-size: 13px;
  color: #757575;
  margin: 0;
`;

const TasksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TaskItem = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`;

const TaskInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TaskText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TaskName = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const TaskReward = styled.div`
  font-size: 14px;
  color: #757575;
`;

const GoButton = styled.button`
  background-color: black;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 6px 20px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
`;

const tasks = [
  { 
    name: 'Boost App', 
    reward: '+1000 $PXL', 
    icon: <StarIcon /> 
  },  { 
    name: 'OKX News', 
    reward: '+200 $PXL', 
    icon: <OkxIcon /> 
  },  { 
    name: 'Binance News', 
    reward: '+200 $PXL', 
    icon: <BinanceIcon /> 
  }
];

const DailyTasks = () => {
  return (
    <TasksContainer>
      <TasksHeader>
        <TasksTitle>Daily tasks</TasksTitle>
        <TasksDescription>Complete tasks to get more $PXL</TasksDescription>
      </TasksHeader>
      
      <TasksList>
        {tasks.map((task, index) => (
          <TaskItem key={index}>
            <TaskInfo>
              {task.icon}
              <TaskText>
                <TaskName>{task.name}</TaskName>
                <TaskReward>{task.reward}</TaskReward>
              </TaskText>
            </TaskInfo>
            <GoButton>GO</GoButton>
          </TaskItem>
        ))}
      </TasksList>
    </TasksContainer>
  );
};

export default DailyTasks;
